import React from 'react';
import { Button, Label } from 'reactstrap';
import PropTypes from 'prop-types';
import { AvGroup } from 'availity-reactstrap-validation';
import AvField from "../../../shared/component/form/AvField";
import Translate from "../../../shared/language/Translate";
import GeneralUtils from '../../../shared/utils/GeneralUtils';
import {
    PAGE_MODE,
    SUBNET_NAME_MEB_CONST,
    TENANT_ID
} from "../../../shared/utils/Constants";
import Toolbar from "../../../shared/component/toolbar/Toolbar";
import { toast } from "react-toastify";
import TenantService from "../../../shared/service/TenantService";
import HsmSubnetNameService from "../../../shared/service/HsmSubnetNameService";

const defaultHsmSubnet = {
    id: '',
    name: '',
    ipAddress: '',
    ipMask: '',
    vlanId: '',
    productId: ''
};

export default class HsmSubnetSave extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            hsmSubnet: defaultHsmSubnet,
            pageMode: null,
            disabledMask: false,
            subnetName: []
        };
        this.tenantService = new TenantService();
        this.hsmSubnetNameService = new HsmSubnetNameService();
    }

    componentDidMount = () => {
        this.hsmSubnetNameService.findAll().then(result => {
            if (!GeneralUtils.isNullOrEmpty(result)) {
                this.setState({ subnetName: result });
            }
        });

        this.tenantService.getTenant().then(result => {
            this.setState({ tenantId: result });
        });


    }

    render() {
        return (
            <div>
                <Toolbar
                    display={true}>
                    <div className="p-toolbar-group-right">
                        <Button color="primary" className="float-right"
                            onClick={this.add}>
                            &nbsp;
                            <Translate contentKey="entity.action.add">Ekle</Translate>
                        </Button>
                        <Button color="primary" className="float-right"
                            onClick={this.props.closeDisplayDialog}>
                            <Translate contentKey="entity.action.add">Vazgeç</Translate>
                        </Button>
                        {this.state.pageMode === PAGE_MODE.UPDATE &&
                            <Button color="primary" className="float-right" onClick={this.delete}>
                                <Translate contentKey="entity.action.delete">Sil</Translate>
                            </Button>
                        }
                    </div>
                </Toolbar>
                <div className="container">
                    <div className="row">
                        <div className="col">
                            <AvGroup>
                                <Label for="nameBB">
                                    <Translate contentKey="hsmSubnet.name">Subnet Adı</Translate>
                                    <span style={{ color: 'red' }}>(*)</span>
                                </Label>
                                <AvField type="select"
                                    className="form-control"
                                    name="nameBB"
                                    value={this.state.hsmSubnet.name}
                                    onChange={this.__handleChangeName}>
                                    <option value='' key='' />
                                    {this.state.subnetName.map(element => (
                                        <option value={element.value} key={element.value}>
                                            {element.name}
                                        </option>
                                    ))}
                                </AvField>
                            </AvGroup>
                            <AvGroup>
                                <Label for="vlanIdBB">
                                    <Translate contentKey="hsmSubnet.vlanId">VLAN ID</Translate>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="vlanIdBB"
                                    disabled={true}
                                    validate={{
                                        maxLength: {
                                            value: 30,
                                            errorMessage: 'Bu alan en fazla 30 karakterden oluşabilir.'
                                        }
                                    }}
                                    value={this.state.hsmSubnet.vlanId}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                        </div>
                        <div className="col">
                            <AvGroup>
                                <Label for="ipAddressBB">
                                    <Translate contentKey="hsmSubnet.ipAddress">IP Adresi</Translate>
                                    <span style={{ color: 'red' }}>(*)</span>
                                </Label>
                                <AvField
                                    type="text"
                                    className="form-control"
                                    name="ipAddressBB"
                                    validate={{
                                        maxLength: {
                                            value: 15,
                                            errorMessage: 'Bu alan en fazla 15 karakterden oluşabilir.'
                                        }
                                    }}
                                    placeholder="000.000.000.000"
                                    value={this.state.hsmSubnet.ipAddress}
                                    onChange={this.__handleChange}
                                />
                            </AvGroup>
                            <AvGroup>
                                <Label for="ipMaskBB">
                                    <Translate contentKey="hsmSubnet.ipMaskBB">IP Mask</Translate>
                                </Label>
                                <AvField
                                    type="number"
                                    className="form-control"
                                    validate={{
                                        maxLength: {
                                            value: 2,
                                            errorMessage: 'Bu alan en fazla 2 karakterden oluşabilir.'
                                        }
                                    }}
                                    name="ipMaskBB"
                                    value={this.state.hsmSubnet.ipMask}
                                    onChange={this.__handleChange}
                                    disabled={this.state.disabledMask}
                                />
                            </AvGroup>
                        </div>
                    </div>
                </div>
            </div>
        );
    }

    setData = (data, pageMode) => {
        this.clearData();
        data.productId = data.productId ? data.productId.id : null;
        this.setState({ hsmSubnet: data, pageMode: pageMode });
    }

    clearData = () => {
        this.setState({ hsmSubnet: Object.assign({}, defaultHsmSubnet), pageMode: null, disabledMask: false });
    }

    __handleChangeName = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let hsmSubnet = this.state.hsmSubnet;
        hsmSubnet[e.target.name.replace("BB", "")] = value;
        if (this.state.tenantId == TENANT_ID.MEB) {
            this.findIpValueAndMask(hsmSubnet);
        }
        // hsmSubnet.vlanId = this.getVlanId(value);
        this.setState({ hsmSubnet: hsmSubnet });
    }

    findIpValueAndMask = (hsmSubnet) => {
        let disabledMask = false;

        // 95 li IP ler reel network olacak.
        // 10. lu IP ler MEB Network(subnet kuralı olmayacak./24 ve /25 değişiyor) olacak.
        // Management Network 172./32
        // WAN IP Block 172./30 olmalıdır
        // MEB Network'e 95 li IP , Reel Network'e 10 lu IP girilmesine sistem müsaade etmemelidir.

        if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.WAN_IP_BLOCK) {
            hsmSubnet.ipAddress = '172.'
            hsmSubnet.ipMask = '30';
            disabledMask = true;
        } else if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.MEB_NETWORK) {
            hsmSubnet.ipAddress = '10.'
            hsmSubnet.ipMask = '';
        } else if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.REEL_NETWORK) {
            hsmSubnet.ipAddress = '95.'
            hsmSubnet.ipMask = '';
        } else if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.MANAGEMENT_NETWORK) {
            hsmSubnet.ipAddress = '172.'
            hsmSubnet.ipMask = '32';
            disabledMask = true;
        }
        this.setState({ hsmSubnet: hsmSubnet, disabledMask });
    }

    __handleChange = (e) => {
        let value = e.target.parsedValue !== undefined ? e.target.parsedValue : e.target.value;
        let hsmSubnet = this.state.hsmSubnet;
        hsmSubnet[e.target.name.replace("BB", "")] = value;
        this.setState({ hsmSubnet: hsmSubnet });
    }

    setAssetIdAndPageMode = (productId, pageMode) => {
        let hsmSubnet = Object.assign({}, defaultHsmSubnet);
        hsmSubnet.productId = productId;
        this.setState({ hsmSubnet: hsmSubnet, pageMode: pageMode });
    }

    add = () => {
        if (GeneralUtils.isNullOrEmpty(this.state.hsmSubnet.name)) {
            return toast.warn("Zorunlu Alan : Lütfen subnet adı giriniz!");
        }
        if (GeneralUtils.isNullOrEmpty(this.state.hsmSubnet.ipAddress)) {
            return toast.warn("Zorunlu Alan : Lütfen IP adresi giriniz!");
        }
        if (this.props.checkName(this.state.hsmSubnet)) {
            return toast.warn("Seçilen Subnet adı tanımlı!");
        }
        let ipAddress = this.state.hsmSubnet.ipAddress;
        if (!GeneralUtils.isNullOrEmpty(ipAddress) && !GeneralUtils.isIP4(ipAddress)) {
            return toast.warn("Lütfen ip adresi alanını kontrol ediniz!");
        }
        let hsmSubnet = this.state.hsmSubnet;
        let ipMask = hsmSubnet.ipMask;

        if (this.state.tenantId == TENANT_ID.MEB) {
            if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.WAN_IP_BLOCK && hsmSubnet.ipAddress.split('.')[0].trim() !== '172') {
                return toast.warn("İp adresi alanı 'WAN IP BLOCK' için 172 ile başlamalıdır!");
            } else if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.REEL_NETWORK && hsmSubnet.ipAddress.split('.')[0].trim() !== '95') {
                return toast.warn("İp adresi alanı 'REEL NETWORK' için 95 ile başlamalıdır!");
            } else if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.MANAGEMENT_NETWORK && hsmSubnet.ipAddress.split('.')[0].trim() !== '172') {
                return toast.warn("İp adresi alanı 'MANAGEMENT NETWORK' için 172 ile başlamalıdır!");
            } else if (hsmSubnet.name === SUBNET_NAME_MEB_CONST.MEB_NETWORK) {
                if (hsmSubnet.ipAddress.split('.')[0].trim() !== '10') {
                    return toast.warn("İp adresi alanı 'MEB NETWORK' için 10 ile başlamalıdır!");
                }
                if (hsmSubnet.ipMask !== '23' && hsmSubnet.ipMask !== '24' && hsmSubnet.ipMask !== '25' && hsmSubnet.ipMask !== '26') {
                    return toast.warn("İp mask alanı 'MEB NETWORK' için 23, 24, 25 ya da 26 olmalıdır!");
                }
            }
        }

        if (!GeneralUtils.isNullOrEmpty(ipMask)) {
            if (ipMask < 1 || ipMask > 32) {
                return toast.warn("İp mask alanı 1-32 arasındaki değerleri alabilir.!");
            }
        }

        if (this.props.add) {
            this.props.add(this.state.hsmSubnet);
        }
        if (this.props.closeDisplayDialog) {
            this.props.closeDisplayDialog();
        }
    }

    delete = () => {
        if (this.props.delete) {
            this.props.delete(this.state.hsmSubnet);
        }
        if (this.props.closeDisplayDialog) {
            this.props.closeDisplayDialog();
        }
    }

}

HsmSubnetSave.propTypes = {
    add: PropTypes.func,
    hsmSubnet: PropTypes.object
};